import './experience.css'

const getYearMonthValue = (yearMonth) => {
  const [year = '0', month = '0'] = String(yearMonth).split('.');
  return Number(year) * 100 + Number(month);
}

const getNewsText = (count, venue) => {
  if (count === 1) {
    return <>One paper accepted by <strong>{venue}</strong>.</>;
  }

  if (count === 2) {
    return <>Two papers accepted by <strong>{venue}</strong>.</>;
  }

  return <>{count} papers accepted by <strong>{venue}</strong>.</>;
}

const Experience = () => {
  const paperData = require('../../database/paper.json')
  const groupedNews = [...paperData.papers]
    .filter((paper) => paper.journal_short && paper.journal_short.toLowerCase() !== 'arxiv')
    .reduce((groups, paper) => {
      const key = `${paper.year}-${paper.journal_short}`;
      if (!groups[key]) {
        groups[key] = {
          year: paper.year,
          venue: paper.journal_short,
          count: 0,
        };
      }
      groups[key].count += 1;
      return groups;
    }, {})

  const newsItems = Object.values(groupedNews).sort((a, b) => getYearMonthValue(b.year) - getYearMonthValue(a.year)).slice(0, 8)

  return (
    <section id='experience'>
      <h2>News</h2>
      <div className="timeline_list">
        {newsItems.map((item) => (
          <article key={`${item.year}-${item.venue}`}>
            <time>{String(item.year)}</time>
            <p>{getNewsText(item.count, item.venue)}</p>
          </article>
        ))}
      </div>

      <h2 className="section_subtitle">Education</h2>
      <div className="experience_grid">
        <article>
          <h3>Bachelor of Science</h3>
          <p>UNSW Sydney - 2019.02 ~ 2021.06</p>
          <span>Computer Science, graduated with distinction</span>
        </article>
        <article>
          <h3>MPhil in Computer Science</h3>
          <p>UNSW Sydney - 2021.09 ~ 2023.06</p>
          <span>Brain-computer interfaces, machine learning, and graph learning</span>
        </article>
        <article>
          <h3>PhD Candidate</h3>
          <p>UNSW Sydney - 2023.09 ~ Present</p>
          <span>Generative AI, speech generation, and large language models</span>
        </article>
      </div>

      <h2 className="section_subtitle">Work Experience</h2>
      <div className="experience_list">
        <article>
          <div className="experience_meta">
            <h3>Academic Tutor</h3>
            <span>UNSW Sydney - Sep 2022 to Present</span>
          </div>
          <p>Tutored COMP3900/9900 Computer Science Project and COMP2041 Software Construction, guiding students through project scoping, sprint planning, Git/GitLab CI workflows, debugging, and software architecture decisions.</p>
        </article>
        <article>
          <div className="experience_meta">
            <h3>Software Testing Intern</h3>
            <span>HCL Tech Australia - Aug 2022 to May 2023</span>
          </div>
          <p>Designed test cases from user stories and functional requirements, maintained frontend and JUnit test scripts with Selenium and Java, and supported regression testing and bug tracking.</p>
        </article>
        <article>
          <div className="experience_meta">
            <h3>Full-Stack Developer</h3>
            <span>VTGMAMA - Sep 2021 to May 2022</span>
          </div>
          <p>Developed a Flask-based e-commerce platform with product search, user management, payment API integration, responsive UI, and an admin dashboard for product and order management.</p>
        </article>
      </div>

      <h2 className="section_subtitle">Projects</h2>
      <div className="project_grid">
        <article>
          <div className="project_header">
            <h3>Achoio</h3>
            <span>Collaborative Speech Evaluation Platform - 2025</span>
          </div>
          <p>Led the design and development of a collaborative AI evaluation platform for collecting and managing human-subjective evaluations of AI-generated speech.</p>
          <a className="project_link" href="https://www.achoio.com/" target="_blank" rel="noreferrer">Demo</a>
          <ul>
            <li>Built real-time data collection and analysis workflows for collaborative rating and qualitative feedback.</li>
            <li>Integrated generative TTS models to support research on style controllability and speech naturalness.</li>
            <li>Stack: Python, FastAPI, React, MongoDB, AWS.</li>
          </ul>
        </article>
        <article>
          <div className="project_header">
            <h3>Miss Yoga</h3>
            <span>Yoga Assistant Mobile Application - 2021</span>
          </div>
          <p>Built a mobile application for real-time yoga pose correction using keypoint detection and camera-based HCI feedback.</p>
          <a className="project_link" href="https://www.youtube.com/watch?v=JNcpdylywhM&ab_channel=MissYoga" target="_blank" rel="noreferrer">Demo</a>
          <ul>
            <li>Designed an on-device inference pipeline for pose comparison and scoring.</li>
            <li>Stack: Android, Kotlin, on-device inference.</li>
          </ul>
        </article>
      </div>
    </section>
  )
}

export default Experience
